import { useHistory } from '@shared/core';
import type { EventPageFragment } from '@graphql/fragments/event.page.graphql.generated';
import { useEventPageRoute } from '@apps/guest/routes/GuestSite/GuestSite.routes';

export const usePageInHistory = (pages?: ReadonlyArray<EventPageFragment>) => {
  const history = useHistory();

  // Extract eventHandle from current pathname (second segment: /eventHandle/...)
  const eventHandle = history.location.pathname.split('/')[1] || '';

  const eventPageRoute = useEventPageRoute(eventHandle, pages);

  const replacePageInBrowserHistory = (page: EventPageFragment | null) => {
    if (!page) {
      return;
    }

    // useEventPageRoute.goToPath handles all routing logic:
    // - Default page → root URL
    // - Whitelisted custom pages → short route
    // - Migrated pages → short route
    // - Other custom pages → /page/ prefix
    // - Query string preservation
    const newPath = eventPageRoute.goToPath(page.type, page.pageSlug);
    const currentPath = history.location.pathname + (history.location.search || '');

    if (newPath !== currentPath) {
      // newPath includes query string, so we extract pathname and search from it
      // but preserve hash and state from current location
      const [pathname, queryString] = newPath.split('?');

      history.replace({
        pathname,
        search: queryString ? `?${queryString}` : '',
        hash: history.location.hash,
        state: history.location.state,
      });
    }
  };

  return replacePageInBrowserHistory;
};
